import { useState, useEffect, Activity } from 'react';
import { NavLink } from 'react-router-dom';

// components
import DropdownDown from '../icons/dropdown-down';
import DropdownUp from '../icons/dropdown-up';

import { AccountsItemTypes } from './types';

// styles
import './item.css';

export default function AccountsItem({
  className,
  to,
  type,
  label,
  id,
  counter = 0,
  children,
  caseSensitive,
  end,
  navLinkStyle,
  setOpenedTabs,
  openedTabs,
  groups,
  onClick,
  number,
  counterIsHidden,
  selectedId,
}: AccountsItemTypes): React.JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (openedTabs?.find((tab) => tab === id)) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [openedTabs, id]);

  return (
    <div className="item-wrap">
      <div className={`item item-${type} ${isOpen ? 'open' : ''}`}>
        <NavLink
          className={`${className} ${
            selectedId === id ? 'selected-active-item' : ''
          }`}
          caseSensitive={caseSensitive}
          to={to}
          end={end}
          style={navLinkStyle}
          onClick={() => onClick && onClick(id)}
        >
          <span>{number}</span>
          {label}
        </NavLink>
        <div className="item-rightside">
          {!counterIsHidden && <div className="item-count">{counter}</div>}
          <button
            type="button"
            className={`item-button ${!children ? 'item-button-hidden' : ''}`}
            onClick={() => {
              let nextOpenedTabs = ([] as string[]).concat(openedTabs);

              if (nextOpenedTabs.find((item) => item === id)) {
                nextOpenedTabs = nextOpenedTabs.filter((item) => item !== id);

                if (type === 'category' && groups?.length) {
                  nextOpenedTabs = nextOpenedTabs.filter((tab) =>
                    groups.every((group) => group.id !== tab),
                  );
                }
              } else {
                nextOpenedTabs.push(id);
              }

              setOpenedTabs(nextOpenedTabs);
            }}
          >
            {children && isOpen ? <DropdownUp /> : <DropdownDown />}
          </button>
        </div>
      </div>
      <Activity
        mode={
          isOpen && children && type !== 'primary-account'
            ? 'visible'
            : 'hidden'
        }
      >
        <div className="item-expandable">{children}</div>
      </Activity>
    </div>
  );
}
